export default "__VITE_ASSET__d8847327__"